<template>
  <div class="positionfixed">
    <Header></Header>
  <div class="pc_all LogoCenter">
    <div class="LogoCenterNav">
      <router-link to="/ailogo/LogoCenter/FreeCreationCenter" class="LogoCenterNav_list font18"
        >自由创作(<span>25</span>)</router-link
      >
      <router-link to="/ailogo/LogoCenter/LetterLogoCenter" class="LogoCenterNav_list font18"
        >字母LOGO(<span>2</span>)</router-link
      >
      <router-link to="/ailogo/LogoCenter/SameCreationCenter" class="LogoCenterNav_list font18 active"
        >同款创作(<span>5</span>)</router-link
      >
      <div class="LogoCenterNav_list font18">已保存(<span>77</span>)</div>
      <div class="LogoCenterNav_list font18">已下载(<span>5</span>)</div>
      <div class="LogoCenterNav_list font18">解析理念(<span>8</span>)</div>
    </div>
    <div class="LogoCenterContent">
      <div class="LogoCenterTitle">
        <div class="LogoCenterTitl_left">
          <div class="LogoCenterTitl_left_dd font24">胖达人</div>
          <div class="LogoCenterTitl_left_dt">
            <div class="left_dt_list font16">A CHUBBY PERSON</div>
            <div class="left_dt_list font16">面包、面点师</div>
            <div class="left_dt_list font16">其他-医药研发</div>
            <div class="left_dt_list font16">吉祥物</div>
            <div class="left_dt_list font16">蓝色</div>
          </div>
        </div>
        <div class="LogoCenterTitl_again font16" @click="toggleClass">
          <img alt="" src="@a/ailogo/images/sv4.svg" />再来一批
        </div>
      </div>
      <div class="LogoCenterContent_logo OScroll">
        <div class="LogoCenterContent_logo_list">
          <div class="logo_list_img"><img alt="" src="@a/ailogo/images/bg11.jpg" /></div>
          <div class="logo_list_btn">
            <router-link to="/ailogo/GenerateManagement/LogoFile" class="list_btn_li font14"
              ><img alt="" src="@a/ailogo/images/sv1.svg" />VI资产</router-link
            >
            <div class="list_btn_li font14">
              <img alt="" src="@a/ailogo/images/sv2.svg" />深度设计
            </div>
            <div class="list_btn_li font14"><img alt="" src="@a/ailogo/images/sv3.svg" />下载</div>
          </div>
        </div>
        <div class="LogoCenterContent_logo_list">
          <div class="logo_list_img"><img alt="" src="@a/ailogo/images/bg12.jpg" /></div>
          <div class="logo_list_btn">
            <router-link to="/ailogo/GenerateManagement/LogoFile" class="list_btn_li font14"
              ><img alt="" src="@a/ailogo/images/sv1.svg" />VI资产</router-link
            >
            <div class="list_btn_li font14">
              <img alt="" src="@a/ailogo/images/sv2.svg" />深度设计
            </div>
            <div class="list_btn_li font14"><img alt="" src="@a/ailogo/images/sv3.svg" />下载</div>
          </div>
        </div>
      </div>

      <div class="LogoCenterWindow" :class="{ active: isActive }">
        <div class="LogoCenterWindow_bg">
          <div class="LogoCenterWindowContent">
            <div class="LogoCenterWindow_title">
              <div class="LogoCenterWindow_title_left font20">
                请调整生成信息再来一批吧<span class="font16">(参考图请尽量不要带文字)</span>
              </div>
              <div class="LogoCenterWindow_title_btn" @click="toggleClass">
                <img alt="" src="@a/ailogo/images/sv5.svg" />
              </div>
            </div>
            <!-- 参考图（必填） -->
            <div class="LogoCenterWindow_list LogoCenterWindow_Img">
              <div class="LogoCenterWindow_list_title font16">参考图（必填）</div>
              <div class="LogoCenterWindow_Img_content"></div>
            </div>

            <div class="SameCreation">
              <div class="SameCreation_left">
                <!-- This section will be hidden when an image is uploaded -->
                <div class="SameCreation_left_icon" v-if="!imageUrl" @click="triggerFileUpload">
                  <div class="left_icon_dd">
                    <img alt="" src="@a/ailogo/images/bn6.png" />
                  </div>
                  <div class="left_icon_dt font16">
                    在此处拖放文件或选择文件<br />支持JPG/JPEG/PNG，20M以内
                  </div>
                </div>

                <input
                  type="file"
                  ref="fileInput"
                  accept="image/*"
                  @change="handleFileUpload"
                  style="display: none"
                />

                <!-- This section will be shown when an image is uploaded -->
                <div class="SameCreation_left_img" v-if="imageUrl">
                  <div
                    class="SameCreation_left_close iconfont icon-a-qingkong1"
                    @click="clearImage"
                  ></div>
                  <img :src="imageUrl" alt="Uploaded Image" />
                </div>
              </div>
              <div class="SameCreation_right">
                <div class="SameCreation_right_title">
                  <div class="LetterLogoTitle font18">
                    如没有参考图，可<span>前往LOGO精选页面</span>选图
                  </div>
                </div>
                <div class="SameCreation_right_title">
                  <div class="LetterLogoTitle font18">没有合适图片？试试</div>
                  <router-link to="/ailogo/EnterBrand/EnterBrand" class="right_title_btn font18"
                    >LOGO自由创作 ></router-link
                  >
                </div>
              </div>
            </div>
            <div class="SameCreationBottom">
              <div class="SameCreationBottomTop">
                <div class="SameCreationBottomTop_list font18">0</div>
                <div class="SameCreationBottomTop_list font18">0.5</div>
                <div class="SameCreationBottomTop_list font18">0.8</div>
              </div>
              <div class="slider-container">
                <input
                  type="range"
                  v-model="threshold"
                  :min="minValue"
                  :max="maxValue"
                  :step="0.01"
                  @input="updateThreshold"
                />
                <!-- <p>当前参考强度: {{ threshold }}</p> -->
              </div>
              <div class="SameCreationBottom_title font16">
                参考强度<span>（数量越大与参考图越相似）</span>
              </div>
            </div>

            <!-- Keyword -->
            <div class="LogoCenterWindow_flex">
              <div class="LogoCenterWindow_list LogoCenterWindow_keyword">
                <div class="LogoCenterWindow_list_title">
                  <div class="list_title_left font16">品牌关键词</div>
                  <div class="list_title_btn font14" @click="ExampleWindowClass">
                    更多示例<img alt="" src="@a/ailogo/images/sv6.svg" />
                  </div>
                </div>
                <div class="LogoCenterWindow_keyword_content">
                  <textarea
                    class="font14"
                    placeholder="请输入您想在LOGO中看到的元素，建议输入3个及以上的关键 比如“龙游车行”可以输入: 跑车，龙，环形等..."
                    v-model="keywordInput"
                    @input="updateCharCount"
                    maxlength="150"
                  ></textarea>
                  <div class="keyword_content_btn font14">
                    <div class="content_btn_lists font14">{{ charCount }}</div>
                    /
                    <div class="content_btn_list font14">150</div>
                    <div class="content_btn_icon"></div>
                    <div class="content_btn_right font14" @click="clearInput">
                      <span class="iconfont icon-a-qingkong1 font14"></span>清空
                    </div>
                  </div>
                </div>
              </div>

              <!-- Keyword2 -->
              <div class="LogoCenterWindow_list LogoCenterWindow_keyword2">
                <div class="LogoCenterWindow_list_title font16">
                  想不好关键词？来试试让AI帮您生成关键词
                </div>
                <div class="LogoCenterWindow_keyword2_content">
                  <div class="keyword2_content_search">
                    <input type="text" placeholder="请输入一句描述语" class="font14" />
                    <div class="content_search_btn font14">提交</div>
                  </div>
                  <div class="keyword2_content_txt">
                    <div
                      class="content_txt_list font12"
                      :class="{ active: activeKeywords.includes(item) }"
                      v-for="(item, index) in keywords"
                      :key="index"
                      @click="toggleKeyword(item)"
                    >
                      {{ item }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Generate -->
            <div class="LogoCenterWindow_generate">
              <div class="LogoCenterWindow_generate_left font16">剩余生成次数：<span>21</span></div>
              <div class="LogoCenterWindow_generate_Recharge font16">
                充值<img alt="" src="@a/ailogo/images/sv6.svg" />
              </div>
              <div class="LogoCenterWindow_generate_btn">立即生成</div>
            </div>
          </div>
        </div>
      </div>
      <div class="ExampleWindow" :class="{ active: ExampleWindowActive }">
        <div class="ExampleWindow_content">
          <div class="ExampleWindow_content_title">
            <div class="content_title_left font20">关键词示例</div>
            <div class="content_title_click" @click="ExampleWindowClass">
              <img alt="" src="@a/ailogo/images/sv5.svg" />
            </div>
          </div>
          <div class="ExampleWindow_content_txt">
            <div class="content_txt_list">
              <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg8.jpg" /></div>
              <div class="txt_list_title font16">竹子，篮子，新鲜的</div>
            </div>
            <div class="content_txt_list">
              <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg9.jpg" /></div>
              <div class="txt_list_title font16">萌芽，女孩侧影，圆形，文艺的</div>
            </div>
            <div class="content_txt_list">
              <div class="txt_list_img"><img alt="" src="@a/ailogo/images/bg10.jpg" /></div>
              <div class="txt_list_title font16">农产品，农民，阳光的</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Header from '@c/header/header'
export default {
  data() {
    return {
      isActive: false,
      ExampleWindowActive: false,
      keywordInput: '',
      charCount: 0,
      keywords: ['老鼠', '染色体', '药物', '科研', '试用药', 'DNA'],
      activeKeywords: [], // Array to hold active keywords
      activeStyle: 0,
      otherColorInput: '',
      threshold: 0.3, // 初始阈值
      minValue: 0, // 最小值
      maxValue: 0.8, // 最大值
      imageUrl: null, // Holds the uploaded image URL
      isNextActive: false // Indicates if the next button should be active
    }
  },
  components: {
    Header
  },
  methods: {
    triggerFileUpload() {
      this.$refs.fileInput.click() // Trigger the hidden file input
    },
    handleFileUpload(event) {
      ;``
      const file = event.target.files[0]
      if (file && file.size < 20 * 1024 * 1024) {
        // Check file size limit (20MB)
        this.imageUrl = URL.createObjectURL(file) // Create a URL for the uploaded image
        this.isNextActive = true // Set the next button to active
      } else {
        alert('文件大小超过限制或格式不正确')
      }
    },
    clearImage() {
      this.imageUrl = null // Clear the uploaded image
      this.$refs.fileInput.value = '' // Reset the file input
      this.isNextActive = false // Set the next button to inactive
    },

    updateThreshold() {
      console.log('当前阈值:', this.threshold) // 确认值是否变化
    },
    toggleClass() {
      this.isActive = !this.isActive
    },
    ExampleWindowClass() {
      this.ExampleWindowActive = !this.ExampleWindowActive
    },
    updateCharCount() {
      this.charCount = this.keywordInput.length
      if (this.charCount > 150) {
        this.keywordInput = this.keywordInput.slice(0, 150)
      }
    },
    clearInput() {
      this.keywordInput = ''
      this.charCount = 0
      this.activeKeywords = [] // Clear all active keywords
    },
    toggleKeyword(item) {
      const keywordsArray = this.keywordInput.split(',').map((keyword) => keyword.trim())
      const keywordIndex = keywordsArray.indexOf(item)

      if (keywordIndex !== -1) {
        // Remove item from textarea
        this.removeKeyword(item)
      } else {
        // Add item to textarea
        this.addKeyword(item)
      }

      // Update charCount after the change
      this.updateCharCount()
    },
    addKeyword(item) {
      if (this.keywordInput) {
        this.keywordInput += `, ${item}`
      } else {
        this.keywordInput = item
      }
      this.activeKeywords.push(item)
    },
    removeKeyword(item) {
      const keywordsArray = this.keywordInput.split(',').map((keyword) => keyword.trim())
      const keywordIndex = keywordsArray.indexOf(item)

      keywordsArray.splice(keywordIndex, 1)
      this.keywordInput = keywordsArray.join(', ')
      this.activeKeywords = this.activeKeywords.filter((keyword) => keyword !== item)
    }
  }
}
</script>


<style>
@import "LogoCenter.css";
</style>